import React from "react";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../lib/site";
import { Reveal } from "../../lib/motion";

export const Testimonials = () => {
  return (
    <section className="py-24 md:py-32" data-testid="testimonials-section">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12">
        <Reveal>
          <p className="font-body text-xs uppercase tracking-[0.3em] text-[#c96c31] mb-5 text-center">
            Loved by our clients
          </p>
          <h2 className="font-display font-light leading-[0.95] tracking-tight text-[#2c1e16] text-4xl sm:text-5xl lg:text-6xl text-center mb-16">
            Words from the chair
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <figure
                data-testid={`testimonial-${i}`}
                className="h-full rounded-3xl border border-[#2c1e16]/10 bg-[#f9f6f0] p-8 md:p-9 flex flex-col"
              >
                <Quote className="text-[#c96c31] mb-5" size={28} />
                <blockquote className="font-display text-xl md:text-2xl leading-snug text-[#2c1e16] italic flex-1">
                  {`\u201C${t.quote}\u201D`}
                </blockquote>
                <figcaption className="mt-7 pt-5 border-t border-[#2c1e16]/10">
                  <p className="font-body text-sm font-semibold text-[#2c1e16]">{t.name}</p>
                  <p className="font-body text-xs uppercase tracking-widest text-[#c96c31] mt-1">{t.role}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
